(() => {
  'use strict';
  if (window.pawhomeInitialized) return;
  window.pawhomeInitialized = true;
  const one = (selector, scope = document) => scope.querySelector(selector);
  const all = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const config = one('[data-ph-config]')?.dataset || {};
  const root = window.Shopify?.routes?.root || '/';
  const productDialog = one('#ph-product-dialog');
  const bagDialog = one('#ph-bag-dialog');
  let lastOpener;
  let cartBusy = false;
  let currentCart;
  let home = one('[data-ph-home]');
  let cards = [];
  let animal = 'all';
  let need = 'all';
  let query = '';
  let sort = 'featured';
  const normalize = value => String(value || '').toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').trim();
  const scrollToDiscovery = () => one('[data-ph-discover]')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  const filter = () => {
    if (!home) return;
    const grid = one('[data-ph-grid]', home);
    const ordered = [...cards].sort((a, b) => {
      if (sort === 'low') return Number(a.element.dataset.price) - Number(b.element.dataset.price) || a.index - b.index;
      if (sort === 'high') return Number(b.element.dataset.price) - Number(a.element.dataset.price) || a.index - b.index;
      if (sort === 'name') return a.element.dataset.title.localeCompare(b.element.dataset.title, config.locale) || a.index - b.index;
      return a.index - b.index;
    });
    let count = 0;
    for (const { element } of ordered) {
      const visible = (animal === 'all' || element.dataset.animal.includes('|' + animal + '|')) && (need === 'all' || element.dataset.need === need) && normalize(element.dataset.search).includes(query);
      element.hidden = !visible;
      if (visible) count += 1;
      grid.append(element);
    }
    one('[data-ph-results]', home).textContent = count + ' ' + config.products;
    one('[data-ph-empty]', home).hidden = count !== 0;
    all('[data-ph-filter]', home).forEach(button => {
      const active = button.dataset.phFilter === animal;
      button.classList.toggle('ph-selected', active);
      button.setAttribute('aria-pressed', String(active));
    });
    all('[data-ph-need]', home).forEach(button => {
      const active = button.dataset.phNeed === need;
      button.classList.toggle('ph-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    all('.ph-desktop-nav [data-ph-animal-link]').forEach(link => link.classList.toggle('ph-active', link.dataset.phAnimalLink === animal));
    one('[data-ph-more]', home).hidden = animal === 'all';
    all('[data-ph-category-more]', home).forEach(link => { link.hidden = link.dataset.phCategoryMore !== animal; });
  };
  const initializeHome = () => {
    home = one('[data-ph-home]');
    if (!home) return;
    cards = all('[data-ph-card]', home).map((element, index) => ({ element, index }));
    const params = new URLSearchParams(window.location.search);
    query = normalize(params.get('ph_search'));
    const selectedAnimal = params.get('ph_pet');
    animal = ['dogs', 'cats', 'horses', 'rabbits', 'lizards', 'birds'].includes(selectedAnimal) ? selectedAnimal : 'all';
    all('[data-ph-search] input').forEach(input => { input.value = params.get('ph_search') || ''; });
    filter();
  };
  const setFormError = (form, message) => {
    const status = one('[data-ph-error]', form);
    if (status) { status.textContent = message; status.hidden = !message; }
  };
  const updateVariant = form => {
    const select = one('[data-ph-variant]', form);
    const selected = select?.selectedOptions[0];
    if (!selected) return;
    one('[data-ph-price]', form).textContent = selected.dataset.price;
    const button = one('[data-ph-add-button]', form);
    button.disabled = selected.dataset.available !== 'true';
    button.textContent = button.disabled ? config.soldOut : config.add;
    const quantity = one('[name="quantity"]', form);
    quantity.min = selected.dataset.min || '1';
    quantity.step = selected.dataset.step || '1';
    quantity.value = quantity.min;
    if (selected.dataset.max) quantity.max = selected.dataset.max;
    else quantity.removeAttribute('max');
    setFormError(form, '');
  };
  const openDialog = (dialog, opener) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    lastOpener = opener;
    if (!dialog.open) dialog.showModal();
    return true;
  };
  const requestCart = async (path, options = {}) => {
    const response = await fetch(root + path, { credentials: 'same-origin', ...options });
    let result;
    try { result = await response.json(); } catch { throw new Error(config.error); }
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : typeof result.message === 'string' ? result.message : config.error);
    return result;
  };
  const make = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  };
  const money = (cents, currency) => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency }).format(cents / 100);
  const renderCart = cart => {
    currentCart = cart;
    all('[data-ph-cart-count]').forEach(element => { element.textContent = cart.item_count; });
    const container = one('[data-ph-bag-items]');
    container.replaceChildren();
    for (const item of cart.items) {
      const row = make('article', 'ph-bag-item');
      const imageBox = make('a', 'ph-bag-item-image');
      imageBox.href = item.url;
      if (item.image) {
        const image = make('img');
        image.src = item.image;
        image.alt = item.product_title;
        image.loading = 'lazy';
        imageBox.append(image);
      }
      const detail = make('div', 'ph-bag-item-copy');
      const title = make('a', '', item.product_title);
      title.href = item.url;
      detail.append(title);
      if (item.variant_title && item.variant_title !== 'Default Title') detail.append(make('p', 'ph-detail-note', item.variant_title));
      detail.append(make('strong', '', money(item.final_line_price, cart.currency)));
      if (item.line_level_discount_allocations?.length) {
        detail.append(make('p', 'ph-discount-note', item.line_level_discount_allocations.map(discount => discount.discount_application.title).join(', ')));
      }
      const controls = make('div', 'ph-bag-item-controls');
      const minimum = item.quantity_rule?.min || 1;
      const step = item.quantity_rule?.increment || 1;
      const maximum = item.quantity_rule?.max;
      const control = (label, quantity, ariaLabel) => {
        const button = make('button', '', label);
        button.type = 'button';
        button.dataset.phChangeKey = item.key;
        button.dataset.phQuantity = quantity;
        button.setAttribute('aria-label', ariaLabel);
        return button;
      };
      const decrease = item.quantity - step < minimum ? 0 : item.quantity - step;
      controls.append(control('−', decrease, config.quantity + ': ' + item.product_title + ' −'), make('span', '', item.quantity));
      const increase = control('+', item.quantity + step, config.quantity + ': ' + item.product_title + ' +');
      increase.disabled = maximum != null && item.quantity + step > maximum;
      controls.append(increase, control(config.remove, 0, config.remove + ': ' + item.product_title));
      detail.append(controls);
      row.append(imageBox, detail);
      container.append(row);
    }
    one('[data-ph-bag-empty]').hidden = cart.item_count !== 0;
    one('[data-ph-bag-summary]').hidden = cart.item_count === 0;
    one('[data-ph-bag-subtotal]').textContent = money(cart.total_price, cart.currency);
  };
  const bagStatus = message => { one('[data-ph-bag-status]').textContent = message; };
  const setCartBusy = busy => {
    cartBusy = busy;
    if (bagDialog) bagDialog.setAttribute('aria-busy', String(busy));
    all('[data-ph-change-key], [data-ph-bag-summary] [name="checkout"]').forEach(button => {
      button.disabled = busy || (button.dataset.phChangeKey && currentCart?.items.some(item => item.key === button.dataset.phChangeKey && item.quantity_rule?.max != null && Number(button.dataset.phQuantity) > item.quantity_rule.max));
    });
    all('[data-ph-add-button]').forEach(button => {
      const form = button.closest('form');
      const unavailable = one('[data-ph-variant]', form)?.selectedOptions[0]?.dataset.available === 'false';
      button.disabled = busy || unavailable;
    });
  };
  document.addEventListener('click', async event => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-ph-close]')) {
      target.closest('dialog').close();
      return;
    }
    if (home && target.matches('[data-ph-animal-link], [data-ph-filter], [data-ph-need], [data-ph-reset]')) {
      event.preventDefault();
      if (target.matches('[data-ph-reset]')) { animal = 'all'; need = 'all'; query = ''; sort = 'featured'; one('[data-ph-sort]', home).value = sort; }
      else if (target.matches('[data-ph-need]')) need = target.dataset.phNeed;
      else { animal = target.dataset.phAnimalLink || target.dataset.phFilter; need = 'all'; query = ''; }
      all('[data-ph-search] input').forEach(input => { input.value = query; });
      filter();
      if (target.matches('[data-ph-animal-link]')) { target.closest('details')?.removeAttribute('open'); scrollToDiscovery(); }
      return;
    }
    if (target.matches('[data-ph-view]')) {
      const template = all('[data-ph-template]').find(element => element.dataset.phTemplate === target.dataset.phView);
      if (!template) return;
      const detail = one('[data-ph-detail]');
      detail.replaceChildren(template.content.cloneNode(true));
      one('h2', detail).id = 'ph-product-dialog-title';
      const form = one('form[data-ph-add]', detail);
      if (form) updateVariant(form);
      openDialog(productDialog, target);
      return;
    }
    if (target.matches('[data-ph-gallery-image]')) {
      const image = one('.ph-main-product-image img');
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = target.dataset.phGalleryImage;
      return;
    }
    if (target.matches('[data-ph-open-bag]')) {
      if (!bagDialog?.showModal) return;
      event.preventDefault();
      if (cartBusy) return;
      openDialog(bagDialog, target);
      setCartBusy(true);
      bagStatus(config.update);
      try { renderCart(await requestCart('cart.js')); bagStatus(''); }
      catch (error) { bagStatus(error.message); }
      finally { setCartBusy(false); }
      return;
    }
    if (target.matches('[data-ph-change-key]')) {
      if (cartBusy) return;
      setCartBusy(true);
      bagStatus(config.update);
      try {
        const cart = await requestCart('cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: target.dataset.phChangeKey, quantity: Number(target.dataset.phQuantity) }) });
        renderCart(cart);
        bagStatus('');
      } catch (error) { bagStatus(error.message); }
      finally { setCartBusy(false); }
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-ph-sort]')) { sort = event.target.value; filter(); }
    if (event.target.matches('[data-ph-variant]')) updateVariant(event.target.closest('form'));
  });
  document.addEventListener('input', event => {
    if (home && event.target.matches('[data-ph-search] input')) { query = normalize(event.target.value); filter(); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (home && form.matches('[data-ph-search]')) { event.preventDefault(); query = normalize(one('input', form).value); filter(); scrollToDiscovery(); return; }
    if (!form.matches('[data-ph-add]') || !bagDialog?.showModal) return;
    event.preventDefault();
    if (cartBusy || !form.reportValidity()) return;
    const payload = new FormData(form);
    const opener = one('[data-ph-add-button]', form);
    setFormError(form, '');
    setCartBusy(true);
    let added = false;
    try {
      await requestCart('cart/add.js', { method: 'POST', body: payload });
      added = true;
      if (productDialog.open) productDialog.close();
      openDialog(bagDialog, opener);
      bagStatus(config.added);
      renderCart(await requestCart('cart.js'));
    } catch (error) {
      if (added) bagStatus(config.added + '. ' + error.message);
      else setFormError(form, error.message);
    } finally { setCartBusy(false); }
  });
  [productDialog, bagDialog].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target === dialog) {
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }
    });
    dialog.addEventListener('close', () => { if (lastOpener?.isConnected) lastOpener.focus(); });
  });
  document.addEventListener('shopify:section:load', initializeHome);
  initializeHome();
})();
